import { createModel } from '@rematch/core'
import { IDLE, FETCHING } from './constants'
import { fetchFrom } from '../utils/fetchData'

interface StateT {
  status: StatusT,
  ssn: string
  bonusStatus: BonusStatusT
}

export type StatusT = 'IDLE' | 'FETCHING' | 'ERROR'
export type BonusStatusT = 'REGISTERED' | 'FAILED' | 'IDLE'

export const customer = createModel()({
  state: {
    status: 'IDLE',
    bonusStatus: 'IDLE',
    ssn: '',
  } as StateT,
  reducers: {
    startFetching (state) {
      return { ...state, status: FETCHING }
    },
    setSsn (state, payload: string) {
      return { ...state, status: IDLE, ssn: payload }
    },
    setBonusStatus (state, payload: BonusStatusT) {
      return { ...state, status: IDLE, bonusStatus: payload }
    },
  },
  effects: (dispatch) => ({
    async validateStammis (payload: { ssn: string }) {
      const { ssn } = payload
      try {
        dispatch.customer.startFetching()

        const isStammis = await fetchFrom(`/customer/${ssn}/loyalty`)

        if (isStammis) {
          dispatch.customer.setBonusStatus('REGISTERED')
          dispatch.customer.setSsn(ssn)

        } else {
          dispatch.customer.setBonusStatus('FAILED')
        }
      } catch (error) {
        console.error('Could not get Stammis status', error as Error)
        dispatch.customer.setBonusStatus('FAILED')
      }
    },
    async addStammisPoints (payload: { storeId: string; orderId: string }, state) {
      const { storeId, orderId } = payload
      const { ssn } = state.customer

      try {
        await fetchFrom(`/order/${orderId}/${storeId}/bonus`, {
          method: 'PUT',
          body: {
            ssn: ssn
          }
        })
      } catch (error) {
        console.error('Failed to register Stammis points', error as Error)
      }
    },
  }),
})